<template lang="html">
  <div>
    <v-avatar color="grey" size="32">
      <span v-if="owner.image==='noimage'" class="white--text headline">
        {{owner.first_name[0].toUpperCase() + owner.last_name[0].toUpperCase()}}
      </span>
      <v-img v-if="owner.image!=='noimage'" height="100%" :src="owner.image">
      </v-img>
    </v-avatar>
    <span class="ml-2">{{ owner.first_name + ' ' + owner.last_name }}</span>
    <!-- <v-icon small class="ml-2" color="blue">mail</v-icon> <span>{{ owner.email }}</span> -->
    <!-- <v-icon small class="ml-2" color="blue">phone</v-icon> <span>{{ owner.phone_number }}</span> -->
  </div>
</template>

<script>
export default {
  name: 'CommunityOwnerDetails',
  props: [ 'owner' ]
}
</script>

<style lang="css" scoped>
</style>
